import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField, MenuItem, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { useStyles } from './style';

interface PrescriptionStepProps {
  control: any;
  errors: any;
  selectedOption: string;
  showExtraFields: boolean;
}

const PrescriptionStep: React.FC<PrescriptionStepProps> = ({
  control,
  errors,
  selectedOption,
  showExtraFields,
}) => {
  const classes = useStyles();
  return (
    <>
      <Controller
        name="prescription"
        control={control}
        rules={{ required: 'Por favor, selecione uma opção' }}
        render={({ field }) => (
          <FormControl component="fieldset" className={classes.textField} error={!!errors.prescription}>
            <FormLabel component="legend">
              Você confirma que possui prescrição médica para o tratamento com Ajovy (fremanezumabe) na apresentação de Solução Injetável 225 mg/1,5 mL para o tratamento de Enxaqueca?
            </FormLabel>
            <RadioGroup {...field} row>
              <FormControlLabel value="true" control={<Radio />} label="Sim" />
              <FormControlLabel value="false" control={<Radio />} label="Não" />
            </RadioGroup>
          </FormControl>
        )}
      />

      {selectedOption === 'true' && showExtraFields && (
        <>
          <Controller
            name="hasStartedTreatment"
            control={control}
            rules={{ required: 'Por favor, selecione uma opção' }}
            render={({ field }) => (
              <FormControl component="fieldset" className={classes.textField} error={!!errors.hasStartedTreatment}>
                <FormLabel component="legend">
                  Você já iniciou o tratamento com Ajovy?
                </FormLabel>
                <RadioGroup {...field} row>
                  <FormControlLabel value='true' control={<Radio />} label="Sim" />
                  <FormControlLabel value='false' control={<Radio />} label="Não" />
                </RadioGroup>
              </FormControl>
            )}
          />

          <Controller
            name="doseFrequency"
            control={control}
            rules={{ required: 'Por favor, selecione uma opção' }}
            render={({ field }) => (
              <TextField
                {...field}
                select
                label="Frequência de Dose"
                variant="outlined"
                fullWidth
                className={classes.textField}
                error={!!errors.doseFrequency}
                helperText={errors.doseFrequency ? errors.doseFrequency.message : ''}
                required
              >
                <MenuItem value="">Selecione</MenuItem>
                <MenuItem value="Semanal">Semanal</MenuItem>
                <MenuItem value="Mensal">Mensal</MenuItem>
                <MenuItem value="Trimestral">Trimestral</MenuItem>
                <MenuItem value="Outros">Outras</MenuItem>
              </TextField>
            )}
          />

          <Controller
            name="diagnosticDate"
            control={control}
            rules={{ required: 'Por favor, preencha o campo' }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Data do Diagnóstico"
                variant="outlined"
                type="date"
                fullWidth
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                error={!!errors.diagnosticDate}
                helperText={errors.diagnosticDate ? errors.diagnosticDate.message : ''}
                required
              />
            )}
          />

          <Controller
            name="cep"
            control={control}
            rules={{ required: 'CEP é obrigatório' }}
            render={({ field }) => (
              <InputMask mask="99999-999" maskChar="" {...field}>
                {(inputProps: any) => (
                  <TextField
                    {...inputProps}
                    label="CEP"
                    variant="outlined"
                    fullWidth
                    className={classes.textField}
                    error={!!errors.cep}
                    helperText={errors.cep ? errors.cep.message : ''}
                    required
                  />
                )}
              </InputMask>
            )}
          />

          <Controller
            name="state"
            control={control}
            rules={{ required: 'UF é obrigatório' }}
            render={({ field }) => (
              <TextField
                {...field}
                label="UF"
                variant="outlined"
                fullWidth
                className={classes.textField}
                error={!!errors.state}
                helperText={errors.state ? errors.state.message : ''}
                required
              />
            )}
          />

          <Controller
            name="city"
            control={control}
            rules={{ required: 'Cidade é obrigatória' }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Cidade"
                variant="outlined"
                fullWidth
                className={classes.textField}
                error={!!errors.city}
                helperText={errors.city ? errors.city.message : ''}
                required
              />
            )}
          />

          <Controller
            name="neighborhood"
            control={control}
            rules={{ required: 'Bairro é obrigatório' }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Bairro"
                variant="outlined"
                fullWidth
                className={classes.textField}
                error={!!errors.neighborhood}
                helperText={errors.neighborhood ? errors.neighborhood.message : ''}
                required
              />
            )}
          />

          <Controller
            name="placeDescription"
            control={control}
            rules={{ required: 'Rua é obrigatória' }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Rua"
                variant="outlined"
                fullWidth
                className={classes.textField}
                error={!!errors.placeDescription}
                helperText={errors.placeDescription ? errors.placeDescription.message : ''}
                required
              />
            )}
          />

          <Controller
            name="number"
            control={control}
            rules={{ required: 'Número é obrigatório' }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Número"
                variant="outlined"
                fullWidth
                className={classes.textField}
                error={!!errors.number}
                helperText={errors.number ? errors.number.message : ''}
                required
              />
            )}
          />

          <Controller
            name="complement"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Complemento"
                variant="outlined"
                fullWidth
                className={classes.textField}
              />
            )}
          />
        </>
      )}
    </>
  );
};

export default PrescriptionStep;
